"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jobListingUpdateSchema = exports.jobListingCreateSchema = exports.jobListingSchema = void 0;
const zod_1 = require("zod");
// Full DB row schema — updated to match Prisma JobListing model fields
exports.jobListingSchema = zod_1.z.object({
    id: zod_1.z.string().cuid().optional(),
    title: zod_1.z.string().min(1).max(255),
    titleEn: zod_1.z.string().max(255).nullable().optional(),
    department: zod_1.z.string().min(1).max(255),
    departmentEn: zod_1.z.string().max(255).nullable().optional(),
    location: zod_1.z.string().max(255).default("İstanbul"),
    locationEn: zod_1.z.string().max(255).nullable().optional(),
    type: zod_1.z.string().max(100).default("Tam Zamanlı"),
    typeEn: zod_1.z.string().max(100).nullable().optional(),
    description: zod_1.z.string().min(1),
    descriptionEn: zod_1.z.string().nullable().optional(),
    active: zod_1.z.boolean().default(true),
});
// API verbatim create/update schemas (source of truth: apps/api/src/common/schemas.ts)
exports.jobListingCreateSchema = zod_1.z.object({
    title: zod_1.z.string().min(1).max(255),
    titleEn: zod_1.z.string().max(255).nullable().optional(),
    department: zod_1.z.string().min(1).max(255),
    departmentEn: zod_1.z.string().max(255).nullable().optional(),
    location: zod_1.z.string().max(255).default("İstanbul"),
    locationEn: zod_1.z.string().max(255).nullable().optional(),
    type: zod_1.z.string().max(100).default("Tam Zamanlı"),
    typeEn: zod_1.z.string().max(100).nullable().optional(),
    description: zod_1.z.string().min(1),
    descriptionEn: zod_1.z.string().nullable().optional(),
    active: zod_1.z.boolean().default(true),
});
exports.jobListingUpdateSchema = zod_1.z.object({
    id: zod_1.z.string().cuid(),
    title: zod_1.z.string().min(1).max(255).optional(),
    titleEn: zod_1.z.string().max(255).nullable().optional(),
    department: zod_1.z.string().min(1).max(255).optional(),
    departmentEn: zod_1.z.string().max(255).nullable().optional(),
    location: zod_1.z.string().max(255).optional(),
    locationEn: zod_1.z.string().max(255).nullable().optional(),
    type: zod_1.z.string().max(100).optional(),
    typeEn: zod_1.z.string().max(100).nullable().optional(),
    description: zod_1.z.string().min(1).optional(),
    descriptionEn: zod_1.z.string().nullable().optional(),
    active: zod_1.z.boolean().optional(),
});
//# sourceMappingURL=job-listing.js.map